var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14C9.5 13.1716 10.1716 12.5 11 12.5H17C17.8284 12.5 18.5 13.1716 18.5 14V20C18.5 20.8284 17.8284 21.5 17 21.5H11C10.1716 21.5 9.5 20.8284 9.5 20V14Z",
    fill: "#C4C4C4",
    stroke: "#717070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.5C15.5 17.3284 14.8284 18 14 18C13.1716 18 12.5 17.3284 12.5 16.5C12.5 15.6716 13.1716 15 14 15C14.8284 15 15.5 15.6716 15.5 16.5Z",
    fill: "#717070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.1338C15 18.6861 14.5523 19.1338 14 19.1338C13.4477 19.1338 13 18.6861 13 18.1338C13 17.5815 13.4477 17.1338 14 17.1338C14.5523 17.1338 15 17.5815 15 18.1338Z",
    fill: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.531 12C11.531 10.6667 11.0361 8 13.9996 8C16.9629 8 16.4692 10.963 16.4692 12",
    stroke: "#717070",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3494 21.25C24 25.5 20.3808 28 14.4175 28C9.945 28 0.999691 25.4038 1 14.5C1.00026 5.15385 7.46028 1 14.4175 1C19.9833 1 24.8533 4.63462 25.3494 10.3462",
    stroke: "#717070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4874 13.0561L22.5776 8.74861L27.6027 8.26932L25.4874 13.0561Z",
    fill: "#717070"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.b0a559a3f342d0d9eed5bfeab9051319.svg";
export { ForwardRef as ReactComponent };